import {
  Component,
  OnInit,
  Input,
  OnDestroy
} from '@angular/core';

import { ButtonsService } from '../buttons.service';
import { ResponsiveService } from '../../responsive/responsive.service';
import { AuthService } from '../../auth/auth.service';
import { ButtonModel } from '../models/button.model';
import { UserModel } from '../../auth/models/user.model';
import { AppState } from '../../app.service';

@Component({
  styleUrls: ['../buttons.scss', './single.component.scss'],
  templateUrl: './single.component.html'
})
export class ButtonsSingleComponent implements OnInit, OnDestroy {
  @Input()
  public stateParams: {code: string};

  public button: ButtonModel;
  public user: UserModel;

  constructor(
    private buttonsService: ButtonsService,
    private authService: AuthService,
    private appState: AppState
  ) {
  }

  public ngOnInit() {
    document.getElementsByTagName('body')[0].classList.add('bg-buttons-listing');

    this.user = this.authService.currentUser;

    this.buttonsService.getOne(this.stateParams.code)
      .subscribe(
        (result) => {
          this.button = result;

          this.appState.set('loading', false);
        }
      );      
  }

  public ngOnDestroy() {
    document.getElementsByTagName('body')[0].classList.remove('bg-buttons-listing');
  }
  
  public getDataToShare() {    
    return {
      image: this.button.getSpiritualImageUrl(),
      title: 'Mut zur Phantasie',
      copy: `Das ist mein Knopf für mehr ${this.button.spiritualText}. Wofür steht Deiner?`,
      buttonCode: this.button.code,
      buttonHtmlLink: `${this.button.code}`,
      shareAButton: true
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/buttons/single/single.component.ts